import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';
import { usePatientExerciseComplianceQuery } from '@/hooks/useTreatmentPlan';

interface ExerciseVideoLabelProps {
  patientId: string;
  exerciseId: string | null;
}

export function ExerciseVideoLabel({ patientId, exerciseId }: ExerciseVideoLabelProps) {
  if (exerciseId === null) {
    return null;
  }
  return <ResolvedExerciseLabel patientId={patientId} exerciseId={exerciseId} />;
}

function ResolvedExerciseLabel({ patientId, exerciseId }: { patientId: string; exerciseId: string }) {
  const { t } = useTranslation('files');
  const complianceQuery = usePatientExerciseComplianceQuery(patientId);
  const rows = complianceQuery.data === undefined ? [] : complianceQuery.data;
  const exercise = rows.find(function matches(row) {
    return row.id === exerciseId;
  });
  return (
    <Badge tone="accent" size="sm">
      {exercise === undefined
        ? t('exerciseVideo')
        : t('exerciseVideoFor', { name: exercise.name })}
    </Badge>
  );
}
